module.exports = __webpack_public_path__ + "img/google.2e9e3078.svg";